export const normalizeExactTimeControl = (value: string | null | undefined): string | null => {
  if (!value || value.length > 64) return null;
  // eslint-disable-next-line security/detect-unsafe-regex -- Input is capped at 64 characters before matching.
  const live = /^([1-9]\d*)(?:\+(\d+))?$/.exec(value);
  if (live && Number.isSafeInteger(Number(live[1])) && Number.isSafeInteger(Number(live[2] ?? 0))) {
    const increment = Number(live[2] ?? 0);
    return increment === 0 ? live[1] : `${live[1]}+${increment}`;
  }
  return /^1\/[1-9]\d*$/.test(value) && Number.isSafeInteger(Number(value.slice(2))) ? value : null;
};
